<div class="container-fluid">
  <div
    class="invoice-header d-flex justify-content-between bg-white align-items-center p-2 mt-4"
  >
    <div class="d-flex align-items-center p-3">
      <button
        mat-button
        class="back-icon text-muted me-2 mat-elevation-z8"
        (click)="goToInvoicePage()"
      >
        <mat-icon class="back-mat-icon">keyboard_backspace</mat-icon>
      </button>
      <h4 class="text-muted">
        Import Account {{ invoiceData?.firstName }} - Handyman
      </h4>
      <span
        [ngClass]="
          status === 'Imported'
            ? 'imported-status'
            : status === 'Error'
              ? 'error-status'
              : 'default-status'
        "
      >
        @if (status === "Imported") {
          <img src="../../../../../assets/icons/Imported.png" alt="" />
        }
        @if (status === "Error") {
          <img src="../../../../../assets/icons/Failed.png" alt="" />
        }
        @if (status === "Open") {
          <img width="50px" src="../../../../../assets/icons/Open.png" alt="" />
        }
      </span>
    </div>

    @if (!isEolContactIdEditable) {
      <div class="col d-flex justify-content-end account-buttons m-3">
        <button
          class="btn text-white"
          mat-raised-button
          class="edit-icon"
          (click)="editEolContactId()"
        >
          <img
            src="../../../../../assets/icons/Edit.png"
            alt="edit icon"
            class="edit-icon"
            width="15"
            height="15"
          />
          <b class="pl-1">Edit</b>
        </button>
      </div>
    } @else {
      <div class="col d-flex justify-content-end account-buttons gap-2 m-3">
        <button
          class="btn text-white bg-success"
          mat-raised-button
          (click)="saveEolContactId()"
        >
          Save<mat-icon>save</mat-icon>
        </button>
        <button
          class="btn text-white bg-secondary"
          mat-raised-button
          (click)="cancelWolContactId()"
        >
          Cancel<mat-icon>cancel</mat-icon>
        </button>
      </div>
    }
  </div>
  <div class="container-fluid bg-white pe-3 px-3 pb-0">
    <h5 class="pt-1 px-3">Data</h5>
    <div class="row pe-3 px-3 pb-0">
      <div class="col">
        <p class="h6">
          Name: <span class="text-muted">{{ invoiceData?.profileName }}</span>
        </p>
        <p class="h6">
          Profile ID:
          <span class="text-muted"> {{ invoiceData?.profileId }}</span>
        </p>
      </div>
      <div class="col">
        <p class="h6">
          Task Id: <span class="text-muted"> {{ invoiceData?.taskId }}</span>
        </p>
        <p class="h6">
          Exact Invoice Number:
          <span class="text-muted"> {{ invoiceData?.eolInvoiceNumber }}</span>
        </p>
        <p class="h6">
          Klusup Invoice Number:
          <span class="text-muted"> {{ invoiceData?.invoiceId }}</span>
        </p>
      </div>
      <div class="col">
        <p class="h6">
          Journal: <span class="text-muted">{{ invoiceData?.journal }}</span>
        </p>
        <p class="h6">
          Invoice Type:
          <span class="text-muted"> {{ invoiceData?.mutationType }} </span>
        </p>
      </div>
    </div>

    @if (!isEolContactIdEditable) {
      <div class="row">
        <div class="d-flex align-items-center h6 gap-2 m-3">
          Exact Contact Id:
          <span class="text-muted"> {{ invoiceData?.eolContactId }}</span>
        </div>
      </div>
    } @else {
      <div class="p-3">
        @if (isEolContactIdEditable) {
          <form [formGroup]="invoiceForm" class="dialog-form">
            <mat-form-field class="full-width">
              <mat-label>Eol Contact Id</mat-label>
              <input matInput formControlName="eolContactId" required />
              @if (invoiceForm.get("eolContactId")?.hasError("required")) {
                <mat-error> Eol Contact Id is required. </mat-error>
              }
            </mat-form-field>
          </form>
        }
      </div>
    }
  </div>

  <!-- <hr class="bg-light" /> -->

  <div class="container-fluid table-wrapper p-0 mb-3">
    <section class="example-container bg-white p-3 table-layout-content" tabindex="0">
      <div class="logs-container">
        <h5 class="pt-3 m-3">
          {{ showLogForm ? "Update Logs" : "Activity & Log" }}
        </h5>
        <div class="col d-flex justify-content-end m-3">
          <button
            class="btn text-white bg-success"
            mat-raised-button
            (click)="updateLogs()"
          >
            {{ showLogForm ? "Show Logs" : "Update Logs" }}
            @if (!showLogForm) {
              <mat-icon>add</mat-icon>
            } @else {
              <mat-icon> edit</mat-icon>
            }
          </button>
        </div>
      </div>

      @if (!showLogForm) {
        <div class="table-container-scroll">
          <section class="table-scroll-region" tabindex="0">
            <table
              mat-table
              [dataSource]="dataSource"
              matSortActive="date"
              matSortDisableClear
              matSortDirection="desc"
              class="bg-white p-2"
            >
              <!-- Name Column -->
              <ng-container matColumnDef="date" sticky>
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="modern-table-header-row"
                >
                  Date
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.creationDate }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name" sticky>
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="modern-table-header-row"
                >
                  Name
                </th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>

              <!-- Position Column -->
              <!-- <ng-container matColumnDef="comment">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="modern-table-header-row"
                  >
                  Description
                </th>
                <td mat-cell *matCellDef="let element">{{ element.description }}</td>
              </ng-container> -->

              <!-- Weight Column -->
              <ng-container matColumnDef="description">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="modern-table-header-row"
                >
                  Comment
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.description }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </section>
        </div>

        <mat-paginator
          class="bg-white table-pagination-fixed"
          [pageSizeOptions]="[5, 10, 20, 50]"
          [length]="totalRecords"
          [pageSize]="currentPageSize"
          [pageIndex]="currentPageIndex"
          (page)="handlePageEvent($event)"
          aria-label="Select page of invoice logs"
        >
        </mat-paginator>
      } @else {
        <section class="example-container bg-white" tabindex="0">
          <app-logs (logData)="getLogData($event)"></app-logs>
        </section>
      }
    </section>
  </div>
</div>
